module.exports = __webpack_public_path__ + "img/close.375b852e.svg";